import { Dropdown } from 'antd';
import React, { FC, ReactNode, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FilterBar } from 'components/molecules/filter-bar';
import { ProjectPlanFilter, ProjectPlanFilters } from 'data/projects';
import { FilterValue, ProjectFilterDropdownButton } from './filters.style';
import { ResponsibleFilter } from './responsible-filters';

const StyledFilterBar = styled(FilterBar)`
  min-height: var(--layout-04);
`;

export const Filters: FC<{
  filters: ProjectPlanFilters;
  selected: ProjectPlanFilter;
  onChange(selected: ProjectPlanFilter): void;
  central: ReactNode;
  secondaryExtra: ReactNode;
}> = ({ filters, selected, onChange, central, secondaryExtra }) => {
  const DropdownMenu = useCallback(() => {
    const handleOnClick = ({ key }) => {
      onChange({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        primary: filters.primary.find((x) => x.id === key)!,
        secondary: selected.secondary,
      });
    };

    return (
      <FilterBar.Menu
        selectedKeys={[selected.primary.id]}
        multiple={false}
        data-cy="projects.plan.views"
      >
        <FilterBar.Menu.Header>
          <FormattedMessage id="view" />
        </FilterBar.Menu.Header>

        {filters.primary.map((option) => (
          <FilterBar.Menu.Item key={option.value} onClick={handleOnClick}>
            {option.label}
          </FilterBar.Menu.Item>
        ))}
      </FilterBar.Menu>
    );
  }, [filters.primary, onChange, selected.primary.id, selected.secondary]);

  return (
    <StyledFilterBar data-preview-enable="true">
      <FilterBar.Primary>
        <Dropdown overlay={DropdownMenu}>
          <ProjectFilterDropdownButton type="text" size="small">
            <FormattedMessage id="projects.filters.filter_selection" />
            <FilterValue>
              {
                filters.primary.find(
                  (option) => option.value === selected.primary.value,
                )?.label
              }
            </FilterValue>
          </ProjectFilterDropdownButton>
        </Dropdown>
      </FilterBar.Primary>
      <FilterBar.Central>{central}</FilterBar.Central>
      <FilterBar.Secondary>
        <ResponsibleFilter
          filterOptions={filters.secondary}
          selected={selected.secondary}
          onChange={(option) =>
            onChange({ primary: selected.primary, secondary: option })
          }
        />
        {secondaryExtra}
      </FilterBar.Secondary>
    </StyledFilterBar>
  );
};
